import { Text, VStack } from "native-base";

import FormButton from "@/components/atoms/FormButton";

import Modal from "../Modal";

export type AlertModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  enableSecondButton?: boolean;
  onPressPrimaryButton: () => void;
  onPressSecondButton?: () => void;
};

const AlertModal = ({
  isOpen,
  title,
  message,
  primaryButtonText = "Ok",
  secondaryButtonText = "Cencelar",
  enableSecondButton = false,
  onClose,
  onPressPrimaryButton,
  onPressSecondButton,
}: AlertModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header={title}
      Body={<Text fontSize="lg">{message}</Text>}
      Footer={
        <VStack w="full">
          <FormButton onPress={() => onPressPrimaryButton()}>{primaryButtonText}</FormButton>
          {enableSecondButton && (
            <FormButton
              colorScheme="white"
              textColor="primary.700"
              my="4"
              shadow="2"
              onPress={() => onPressSecondButton()}>
              {secondaryButtonText}
            </FormButton>
          )}
        </VStack>
      }
    />
  );
};

export default AlertModal;
